import "./SelectTweet.css";
import checkMark from "../../images/Svg/CheckMark.svg";
import DownVector from "../../images/Svg/DownVector.svg";
import upVector from "../../images/Svg/upVector.svg";
import search from "../../images/Svg/search.svg";
import moment from "moment";
import commentIcon from "../../images/Svg/comment.svg";
import retweetIcon from "../../images/Svg/Retweet.svg";
import loveIcon from "../../images/Svg/Love.svg";
import Share from "../../images/Svg/Share.svg";
import WhiteCheck from "../../images/Svg/WhiteCheck.svg";
import whiteMark from "../../images/Svg/WhiteCheck.svg";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { handleRealTimeSync, setCartStates } from "../../reducers/auth/action";
import Spinner from "../../components/spinner/Spinner.component";
import SortButton from "../../components/SelectTweet/SortButton.component";
import {
  getAvailableSelectedApi,
  getDerivedKeyStatusApi,
  getTweetApi,
  selectedTweetsTransferApi,
} from "../../Network/network";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { ConfigContext } from "../../context/config";
import useIdentity from "../../utils/identity";
import { Toast } from "../../components/Toast/Toast.components";
import GetDesoProfile from "../../Hooks/GetDesoProfile";
import Iframe from "../../components/iframe/Iframe.component";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerInput from "../../components/Common/DatePickerInput";
import StepComponents, {
  checkArray,
  checkingStep2,
} from "../../components/Dashboard/Step.components";
import RealTimeSyncModal from "../../components/RealTimeSyncModal/RealTimeSyncModal";
import { Helmet } from "react-helmet";
import { deriveUrl } from "../RealTimeSync/RealTimeSync.page";
import Swal from "sweetalert2";
import { pushGaEvent } from "../../utils/ga_events";
const parse = require("html-react-parser");

const wordpressData = [
  {
    text: "Where to grow your business as a photographer: site or social media?",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil obcaecati tempora beatae magnam nesciunt iure? Iste velit laborum odit quasi cum rem tempore molestias. Quo non ducimus, laboriosam nihil odio, fuga eaque dicta optio!",
    image: "https://picsum.photos/200/300",
    date: "June 12, 2021",
    love: 12,
    comment: 12,
  },
  {
    text: "How to make your Instagram profile stand out",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil obcaecati tempora beatae magnam nesciunt iure? Iste velit laborum odit quasi cum rem tempore molestias. Quo non ducimus, laboriosam nihil odio, fuga eaque dicta optio!",
    image: "https://picsum.photos/200/300",
    date: "June 14, 2021",
    love: 14,
    comment: 14,
  },
  {
    text: "Where to grow your business as a photographer",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil obcaecati tempora beatae magnam nesciunt iure? Iste velit laborum odit quasi cum rem tempore molestias. Quo non ducimus, laboriosam nihil odio, fuga eaque dicta optio!",
    image: "https://picsum.photos/200/300",
    date: "June 12, 2021",
    love: 12,
    comment: 12,
  },
  {
    text: "How to make your Instagram profile stand out",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil obcaecati tempora beatae magnam nesciunt iure? Iste velit laborum odit quasi cum rem tempore molestias. Quo non ducimus, laboriosam nihil odio, fuga eaque dicta optio!",
    image: "https://picsum.photos/200/300",
    date: "June 14, 2021",
    love: 14,
    comment: 14,
  },
];

const SelectTweet = () => {
  const TuserName = localStorage.getItem("twitter_username");
  const { id } = useParams();

  const { identityWindow } = useContext(ConfigContext);
  const { handleMessage, selectedTweetsTransferIdentity } = useIdentity();

  useEffect(() => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
  }, [identityWindow]);

  const { username } = GetDesoProfile();
  const { twitter, deso, realTimeModal } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const setCartDispatch = (value) => dispatch(setCartStates(value));
  const navigate = useNavigate();
  useEffect(() => {
    if (TuserName) {
    } else {
      navigate("/");
    }
  }, [TuserName]);
  // states
  const [tweets, setTweets] = useState();
  const [displayTweets, setDisplayTweets] = useState();
  const [loading, setLoading] = useState(true);
  const [showSelectMenu, setShowSelectMenu] = useState(false);
  const [filter, setFilter] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [cartState, setCartState] = useState([]);
  const [filterPostion, setfilterPostion] = useState();
  const [countValue, setCountValue] = useState({ min: 0, max: 0 });
  const [maxLike, setMaxLike] = useState(0);
  const [selectState, setSelectState] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [disableData, setDisableData] = useState(false);
  const [text, setText] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchingError, setSearchingError] = useState(false);
  const [filterError, setFilterError] = useState(false);
  const [sortingText, setSortingText] = useState("Latest");

  useEffect(() => {
    if (twitter?.user && id == "twitter") {
      fetchData();
    } else if (id == "wordpress") {
      fetchWordPressData();
    }
  }, [twitter?.user]);
  // wordpress calling api

  const fetchWordPressData = () => {
    setTweets(wordpressData);
    setDisplayTweets(wordpressData);
    setLoading(false);
  };

  let bodyData = {
    count: 100,
    // username: "mohit_badwal",
    user_id: twitter?.user?.providerData[0]?.uid,
  };
  // check
  useEffect(() => {
    if (deso?.user) selectApiFetchData();
  }, [deso, cartState]);

  let bodyTweetData = {
    public_key: deso?.user?.publicKeyAdded,
  };

  const handleUnselect = () => {
    setSelectState(false);
    setCartState([]);
    setCartDispatch([]);
    localStorage.removeItem("cart");
  };

  const selectApiFetchData = async () => {
    const res = await getAvailableSelectedApi(bodyTweetData);
    const time = res?.time_remaining;
    const limit = res?.count_today;
    const shift = 25 - parseInt(limit);
    let demoText = "";
    if (time <= 60) {
      const minutes = Math.round(time % 60);
      demoText = ` ${minutes} minutes.`;
    } else {
      const hours = Math.round(time / 60);
      demoText = ` ${hours} hours.`;
    }
    if (limit === 25) {
      setDisableData(true);
      setText(
        `<span className="text-[16px] text-blue">25 tweets have been synced. Come back in<span className="hidden sm:hidden lg:inline"><br /></span> ${demoText}  to sync your tweets again!</span>`
      );
    } else if (shift < cartState?.length) {
      setDisableData(true);
      setText(
        `<span className="font-bold text-[20px] text-[#161616]"> You can sync up to ${shift} more tweets today. </span>`
      );
    } else {
      setDisableData(false);
      setText(
        `You can sync as many <span className='md:hidden'> <br /> </span> as ${shift} tweets today`
      );
    }
  };

  let max = 0;
  const fetchData = async () => {
    const res = await getTweetApi(bodyData);
    for (const tweet of res) {
      let count = tweet?.public_metrics?.like_count;
      if (count > max) {
        max = count;
      }
    }
    setMaxLike(max);
    setCountValue({ min: 0, max: max });
    setTweets(res);
    setDisplayTweets(res);
    setLoading(false);
  };

  const handleSearch = (text, tweets, check) => {
    const matchTweet = tweets?.filter((tweet) =>
      tweet.text.toLowerCase().includes(text?.toLowerCase())
    );
    if (matchTweet.length !== 0) {
      setDisplayTweets(matchTweet);
      if (check) {
        handleApply(matchTweet, false);
      }
      setSearchingError(false);
    } else setSearchingError(true);

    return matchTweet;
  };
  const handleCount = (min, sortingTweets = displayTweets) => {
    let tweets = [];
    if (min) {
      tweets = sortingTweets?.sort(
        (a, b) => a?.public_metrics?.like_count - b?.public_metrics?.like_count
      );
      setSortingText("Lowest ...");
    } else {
      tweets = sortingTweets?.sort(
        (a, b) => b?.public_metrics?.like_count - a?.public_metrics?.like_count
      );
      setSortingText("Highest ...");
    }
    setDisplayTweets(tweets);
    setShowSelectMenu(false);
  };
  const handleNewest = (sortingTweets = displayTweets) => {
    const newest = sortingTweets?.sort(function (a, b) {
      var d = new Date(b.created_at);
      var c = new Date(a.created_at);
      return d - c;
    });
    setSortingText("Latest");
    setDisplayTweets(newest);
    setShowSelectMenu(false);
  };
  const handleOldest = (sortingTweets = displayTweets) => {
    const oldestTweet = sortingTweets?.sort(function (a, b) {
      var c = new Date(a.created_at);
      var d = new Date(b.created_at);
      return c - d;
    });
    setSortingText("Oldest");
    setDisplayTweets(oldestTweet);
    setShowSelectMenu(false);
  };

  const navbarShow = () => {
    if (window.scrollY > 100) {
      setfilterPostion(true);
    } else {
      setfilterPostion(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", navbarShow);
    return () => window.removeEventListener("scroll", navbarShow);
  }, []);

  const handleSelectAll = () => {
    if (!filterError && !searchingError) {
      setSelectState(!selectState);
      if (!selectState) {
        setCartDispatch(displayTweets);
        setCartState(displayTweets);
        localStorage.setItem("cart", JSON.stringify(displayTweets));
      } else {
        handleUnselect();
      }
    }
  };

  const handleRange = (e) => {
    setCountValue(e);
  };

  useEffect(() => {
    if (modalShow) {
      document.body.style.overflow = "hidden";
    }
  }, [modalShow]);

  const handleSyncContent = async () => {
    pushGaEvent(`${id}_SYNC_CONTENT_BUTTON_CLICKED`);
    localStorage.setItem("cart", JSON.stringify(cartState));

    let bodyData = {
      public_key: deso?.user?.publicKeyAdded,
    };

    if (cartState.length != 0) {
      console.log("calling");
      const res = await getDerivedKeyStatusApi(bodyData);
      const tweets = localStorage.getItem("cart");
      const formData = new FormData();
      formData.append("tweets_data", tweets);
      formData.append("public_key", deso?.user?.publicKeyAdded);
      formData.append("username_deso", username);
      formData.append("twitter_user_id", twitter?.user?.providerData[0]?.uid);
      dispatch(handleRealTimeSync(formData));
      sessionStorage.setItem("sync_past_tweet", "sync_past_tweet");
      if (res?.status === "success" && res?.is_expired === false) {
        window.addEventListener("message", (event) =>
          handleMessage(event, identityWindow)
        );
        selectedTweetsTransferIdentity();
      } else {
        Swal.fire({
          icon: "",
          html: "You will be redirected to Deso identity. Press Ok to continue",
          focusConfirm: false,
          confirmButtonText: "ok!",
        }).then((result) => {
          identityWindow.current = window.open(deriveUrl, null);
        });
      }
    } else {
      Toast.fire({
        icon: "warning",
        title: "Please add Tweets",
      });
    }
  };

  const helpingSorting = (tweet) => {
    if (sortingText === "Lowest ...") {
      handleCount(true, tweet);
    } else if (sortingText === "Highest ...") {
      handleCount(false, tweet);
    } else if (sortingText === "Latest") {
      handleNewest(tweet);
    } else if (sortingText === "Oldest") {
      handleOldest(tweet);
    }
  };

  const handleApply = (tweet, check) => {
    let matchTweet = tweet;
    if (matchTweet.length !== 0) {
      if (fromDate && toDate) {
        matchTweet = matchTweet?.filter((tweet) => {
          let date = new Date(tweet.created_at);
          let from = new Date(fromDate);
          let y = new Date(toDate);
          return date >= from && date <= y;
        });
      }
    }
    if (matchTweet.length !== 0) {
      matchTweet = matchTweet?.filter(
        (tweet) =>
          tweet?.public_metrics?.like_count >= countValue.min &&
          tweet?.public_metrics?.like_count <= countValue.max
      );
    }
    if (matchTweet.length != 0) {
      helpingSorting(matchTweet);
      setDisplayTweets(matchTweet);
      setFilterError(false);
      if (check) {
        const searchingTweet = handleSearch(searchText, matchTweet);
        if (searchingTweet.length == 0) setSearchingError(true);
        else setSearchingError(false);
      }
    } else {
      setFilterError(true);
      setSearchingError(true);
    }
  };

  const handleReset = () => {
    setCountValue({ min: 0, max: maxLike });
    setFromDate();
    setToDate();
    setSearchingError(false);
    setFilterError(false);
    handleSearch(searchText, tweets);
  };

  const pn = window.location.pathname;
  const result = checkArray(checkingStep2, pn);
  if (result) {
  } else {
    window.location.href = "/";
  }

  // select all layout
  const SelectAllLayout = () => {
    return (
      <div>
        <div
          onClick={handleSelectAll}
          className={`${selectState ? "bg-[#EEEFFF]" : ""} ${
            id == "twitter" ? "w-[135px] h-[40px]" : "w-[159px] h-[48px]"
          } flex cursor-pointor  justify-center items-center rounded-[4px]`}
        >
          <img
            className="w-[24px] h-[24px]"
            src={selectState ? checkMark : whiteMark}
            alt=""
          />
          <p className="mx-2">Select all</p>
        </div>
      </div>
    );
  };
  // love icon
  const LoveLayout = ({ icon, val }) => {
    return (
      <div className="flex items-center">
        <img className="w-[22px] h-[22px]" src={icon} alt="" />
        <p className="mx-1 text-[14px]">{val}</p>
      </div>
    );
  };
  return (
    <section className={``}>
      <Helmet>
        <title>Setu - Sync Past Content</title>
        <meta
          name="description"
          content="Sync you content to Deso using Setu in real time"
        />
      </Helmet>
      <div className={`container px-4 sm:px-4 md:px-16 lg:py-[16px] mx-auto`}>
        {loading ? (
          <div className="h-[80vh] items-center flex justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            <Iframe />
            <StepComponents />

            {(modalShow || realTimeModal) && (
              <RealTimeSyncModal deleteShow={false} real_time_show={false} />
            )}
            {/* filter section */}
            {id == "twitter" ? (
              <>
                <div className="grid sm:grid-cols-1 lg:grid-cols-2">
                  <div>
                    <div
                      className={`${
                        filterPostion ? "top-[10px]" : " "
                      } lg:sticky`}
                    >
                      <div className="mb-[24px] lg:max-w-[364px] w-[100%]">
                        <h1 className="text-[36px] font-bold">
                          Select Past Tweets
                        </h1>
                        <p className="text-[16px] text-[#161616] mb-[24px]">
                          You can view upto 100 of your past tweets.
                        </p>
                        <div className="w-[100%] sm:w-[100%] lg:w-[364px] filter-button bg-white border sm:mx-0 border-[#E1E1E1] p-3 rounded-[8px] mb-[16px]">
                          <img className="px-3" src={search} alt="" />
                          <input
                            onChange={(e) => {
                              setSearchText(e.target.value);
                              handleSearch(e.target.value, tweets, true);
                            }}
                            type="search"
                            className="w-[100%] sm:w-[100%] lg:w-[364px]"
                            placeholder="Search #hashtags"
                          />
                        </div>
                        <div className="w-[100%] sm:w-[100%] lg:w-[364px] bg-[#F6F7FF] border border-[#E1E1E1] rounded-[8px] py-[12px] px-[16px] sm:px-[16px] lg:px-[8px]">
                          <button
                            onClick={() => setFilter(!filter)}
                            className=" w-[100%] lg:w-[340px] bg-[#F6F7FF] filter-button mx-0 lg:px-2"
                          >
                            <span className="text-[20px] text-[#161616]">
                              Filters
                            </span>
                            <img
                              className="w-[20px] h-[15px]"
                              src={filter ? upVector : DownVector}
                              alt=""
                            />
                          </button>
                          {filter && (
                            <div className="lg:px-[8px]">
                              {" "}
                              <div className="mt-[16px]">
                                <span className="text-[16px] text-[#161616]">
                                  Filter by Date
                                </span>
                                <form className="flex mt-[16px]">
                                  <DatePickerInput
                                    date={fromDate}
                                    text={"From"}
                                    fun={setFromDate}
                                  />
                                  <DatePickerInput
                                    date={toDate}
                                    text={"To"}
                                    fun={setToDate}
                                    startDate={fromDate}
                                  />
                                </form>
                              </div>
                              <div className="mt-[24px]">
                                <span className="text-[16px] text-[#161616]">
                                  Filter by Engagements
                                </span>
                                <div className="mx-2 ">
                                  <InputRange
                                    maxValue={maxLike}
                                    minValue={0}
                                    formatLabel={(value) => `${value}`}
                                    onChange={(e) => handleRange(e)}
                                    value={countValue}
                                  />
                                  <div className="flex justify-between mb-[16px]">
                                    <p className="text-[16px] text-[#161616]">
                                      0 Likes
                                    </p>
                                    <p className="text-[16px] text-[#161616]">
                                      {maxLike} Likes
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-evenly">
                                <button
                                  className="hover:text-[#585858]"
                                  onClick={handleReset}
                                >
                                  Reset
                                </button>
                                <button
                                  onClick={() => handleApply(tweets, true)}
                                  className="w-[99px] filter-button justify-center bg-white p-3 rounded-[8px] border border-[#E1E1E1] hover:shadow-md"
                                >
                                  Apply
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className={`${
                          disableData
                            ? "h-[90px]"
                            : "h-[100px] grid sm:grid grid-cols-2"
                        } mt-[40px] bg-white sm:bg-white   bottom-0 fixed sm:fixed lg:static left-[0px]  sm:h-[98px] sm:left-[0px] w-[100%] lg:inline-block gap-4 items-center mx-auto shadow-class`}
                      >
                        <div className="pl-[16px] sm:pl-[5px] md:pl-[10px] lg:pl-[0px]">
                          {!disableData && (
                            <h3 className="text-blue text-[16px] sm:text-[16px] md:text-[24px] font-bold">
                              {cartState?.length} tweets selected
                            </h3>
                          )}
                          <p className="text-[14px] mt-[8px] text-[#161616]">
                            {parse(text)}
                          </p>
                        </div>

                        {!disableData && (
                          <div
                            className={
                              disableData ? "cursor-default" : "button_hover"
                            }
                          >
                            <button
                              disabled={disableData}
                              onClick={handleSyncContent}
                              className={`${
                                disableData
                                  ? "border-[#E1E1E1] border cursor-text"
                                  : "bg-[#5463FF] text-white"
                              } lg:mt-[16px] h-[48px]  rounded-[8px] w-[160px] sm:w-[160px] md:w-[202px] justify-center`}
                            >
                              <span>Sync Content</span>{" "}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div></div> */}

                  <div className="mt-6 sm:mt-6 lg:mt-0">
                    <div className="flex items-center justify-between">
                      <SelectAllLayout />
                      <SortButton
                        menu={showSelectMenu}
                        setMenu={setShowSelectMenu}
                        newest={handleNewest}
                        old={handleOldest}
                        min={handleCount}
                        max={handleCount}
                        title={sortingText}
                        tweets={displayTweets}
                      />
                    </div>
                    {searchingError || filterError ? (
                      <p className="mt-[72px] text-[20px] text-[#000000] max-w-[400px] w-[100%] mx-auto">
                        Your search did not match any tweets. Make sure that all
                        words are spelled correctly or try different keywords.
                      </p>
                    ) : (
                      <div className="min-h-[90vh] mt-[14px] w-full">
                        {displayTweets?.map((data, index) => {
                          let check;
                          const checkTweet = () => {
                            if (cartState.length > 0) {
                              cartState.map((item) => {
                                if (item.id === data.id) {
                                  check = true;
                                }
                              });
                            }
                            return check;
                          };
                          checkTweet();

                          const handleCheckMark = (data) => {
                            setCartState([...cartState, data]);
                          };
                          const handleUncheck = (id) => {
                            const newCartState = cartState.filter(
                              (item) => item.id !== id
                            );
                            setCartState(newCartState);
                          };
                          return (
                            <div
                              key={index}
                              onClick={
                                check
                                  ? () => handleUncheck(data.id)
                                  : () => handleCheckMark(data)
                              }
                              className={`${
                                check ? "bg-[#F7F7F7]" : "bg-[#FFFFFF]"
                              } flex items-center cursor-pointer w-full`}
                            >
                              <div className="mr-2 px-[14px]">
                                {check ? (
                                  <img
                                    className="w-[24px] h-[24px]"
                                    src={checkMark}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    className="w-[24px] h-[24px]"
                                    src={WhiteCheck}
                                    alt=""
                                  />
                                )}
                              </div>
                              <div className="flex w-full shadow p-4">
                                <img
                                  className="w-[30px] h-[30px] rounded-[30px]"
                                  src={twitter?.user?.photoURL}
                                  alt=""
                                />

                                <div className="w-full">
                                  <div className="flex">
                                    <p className="mx-2 sm:mx-2 lg:mx-3 lg:text-[16px] font-bold text-[14px] sm:text-[14px]">
                                      <span className="lg:hidden">
                                        {twitter?.user?.displayName
                                          .slice(0, 5)
                                          .concat("...")}
                                      </span>
                                      <span className="hidden sm:hidden lg:inline-block">
                                        {twitter?.user?.displayName}
                                      </span>
                                    </p>
                                    <p className="mx-2 sm:mx-2 lg:mx-3 text-[#506473] text-[14px] sm:text-[14px]">
                                      @
                                      <span className="lg:hidden">
                                        {localStorage
                                          .getItem("twitter_username")
                                          ?.slice(0, 5)
                                          ?.concat("...")}
                                      </span>
                                      <span className="hidden sm:hidden lg:inline-block">
                                        {localStorage.getItem(
                                          "twitter_username"
                                        )}
                                      </span>
                                    </p>
                                    <h1 className="text-[#506473]  text-[14px] sm:text-[14px]">
                                      {moment(data.created_at).format(
                                        "MMM Do YY"
                                      )}{" "}
                                    </h1>
                                  </div>
                                  <div>
                                    <div className="text-area mt-[5px] px-2">
                                      <span>
                                        {parse(
                                          data?.text.replaceAll("\n", "<br />")
                                        )}
                                      </span>
                                    </div>
                                    <br />

                                    <div>
                                      {data.media.map((res, index) => {
                                        return res.media_type == "photo" ? (
                                          <img
                                            key={index}
                                            src={res?.media_url}
                                            alt=""
                                          />
                                        ) : (
                                          <video controls className="w-[100%]">
                                            <source
                                              src={res?.media_url}
                                              type="video/mp4"
                                            />
                                          </video>
                                        );
                                      })}
                                    </div>
                                  </div>
                                  <div className="flex mt-3 justify-between ">
                                    <LoveLayout
                                      icon={commentIcon}
                                      val={data?.public_metrics?.reply_count}
                                    />
                                    <LoveLayout
                                      icon={retweetIcon}
                                      val={data?.public_metrics?.retweet_count}
                                    />
                                    <LoveLayout
                                      icon={loveIcon}
                                      val={data?.public_metrics?.like_count}
                                    />
                                    <div>
                                      <img
                                        className="w-[22px] h-[22px]"
                                        src={Share}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                {(displayTweets?.length == 0 ||
                  searchingError ||
                  filterError) && <div className="lg:h-[400px]"></div>}
              </>
            ) : (
              <>
                <h1 className="thirdHeading text-center">
                  Select Blogs to Sync
                </h1>
                <div className="flex mt-[32px] justify-between">
                  <div className="flex items-center">
                    <SelectAllLayout />
                    <div className="lg:ml-[48px]">
                      <div className="w-[100%] sm:w-[100%] lg:w-[364px] filter-button bg-white border sm:mx-0 border-[#E1E1E1] p-3 rounded-[8px]">
                        <img className="px-3" src={search} alt="" />
                        <input
                          onChange={(e) => {
                            setSearchText(e.target.value);
                            handleSearch(e.target.value, tweets, false);
                          }}
                          type="search"
                          className="w-[100%] sm:w-[100%] lg:w-[364px]"
                          placeholder="Search #hashtags"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    {!disableData && (
                      <div
                        className={
                          disableData ? "cursor-default" : "button_hover"
                        }
                      >
                        <button
                          disabled={disableData}
                          onClick={handleSyncContent}
                          className={`${
                            disableData
                              ? "border-[#E1E1E1] border cursor-text"
                              : "bg-[#5463FF] text-white"
                          } h-[48px]  rounded-[8px] w-[160px] sm:w-[160px] md:w-[202px] justify-center`}
                        >
                          <span>Sync Content</span>{" "}
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {searchingError || filterError ? (
                  <p className="text-[20px] mt-[24px] text-[#000000] max-w-[400px] w-[100%] mx-auto">
                    Your search did not match any blogs. Make sure that all{" "}
                    words are spelled correctly or try different keywords.
                  </p>
                ) : (
                  <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 relative">
                    {displayTweets?.map((data, index) => {
                      let check;
                      const checkBolgs = () => {
                        if (cartState.length > 0) {
                          cartState.map((item) => {
                            if (item.text === data.text) {
                              check = true;
                            }
                          });
                        }
                        return check;
                      };
                      checkBolgs();

                      const handleCheckMarkBlogs = (data) => {
                        setCartState([...cartState, data]);
                      };
                      const handleUncheckBlogs = (text) => {
                        const newCartState = cartState.filter(
                          (item) => item.text !== text
                        );
                        setCartState(newCartState);
                        setSelectState(false);
                      };
                      return (
                        <>
                          <div
                            key={index}
                            className={`${
                              check
                                ? "border-[2px] border-[#5463FF] bg-[#F7F7F7]"
                                : "border border-[#FFFFFF]"
                            } wordpress_card  cursor-pointer`}
                            onClick={
                              check
                                ? () => handleUncheckBlogs(data.text)
                                : () => handleCheckMarkBlogs(data)
                            }
                          >
                            <div className="absolute top-[28px] left-[40px] ">
                              {check ? (
                                <img src={checkMark} alt="" />
                              ) : (
                                <img src={WhiteCheck} alt="" />
                              )}
                            </div>
                            <img
                              className="w-[100%] h-[209px] object-cover"
                              src={data?.image}
                              alt=""
                            />
                            <div className="my-[12px] wordpress_card_body">
                              <h1 className="text-[20px] font-bold">
                                {data.text}
                              </h1>
                            </div>
                            <div>
                              <p className="mb-[12px]">
                                {" "}
                                {data?.description.slice(0, 150).concat("...")}
                              </p>

                              <div className="flex items-center justify-between">
                                <p>{data?.date}</p>
                                <div className="flex items-center">
                                  <LoveLayout
                                    icon={commentIcon}
                                    val={data?.comment}
                                  />
                                  <LoveLayout
                                    icon={loveIcon}
                                    val={data?.love}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default SelectTweet;
